// `key in obj` for (obj: unknown) doesn't assert the type safety of `obj[key]` in TypeScript <4.9
// https://github.com/microsoft/TypeScript/issues/21732
export function hasKey<K extends string, T extends object>(k: K, o: T): o is T & Record<K, unknown> {
  return k in o;
}
